<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view/>
  </div>
</template>
<script>
	import { qiniu } from '@/api'
	export default {
		data() {
			return{
				
			}
		},
		created() {
			this.getQiniu()
		},
		methods:{
			// 获取七牛地址
			getQiniu(){
				qiniu().then(res =>{
					if(res.code == 200){
						// console.log(res)
						localStorage.setItem('qiniu',res.data.url)
					}else{
						console.log(res.msg)
					}
				})
			}
		}
	}
</script>
<style type="text/css">
		html, body, div, span, applet, object, iframe,
		h1, h2, h3, h4, h5, h6, p, blockquote, pre,
		a, abbr, acronym, address, big, cite, code,
		del, dfn, em, img, ins, kbd, q, s, samp,
		small, strike, strong, sub, sup, tt, var,
		b, u, i, center,
		dl, dt, dd, ol, ul, li,
		fieldset, form, label, legend,
		table, caption, tbody, tfoot, thead, tr, th, td,
		article, aside, canvas, details, embed, 
		figure, figcaption, footer, header, hgroup, 
		menu, nav, output, ruby, section, summary,
		time, mark, audio, video {
		    margin: 0;
		    padding: 0;
		    border: 0;
		   /* font-size: 100%;
		    font: inherit; */
		    vertical-align: baseline;
		}
		/* HTML5 display-role reset for older browsers */
		article, aside, details, figcaption, figure, 
		footer, header, hgroup, menu, nav, section {
		    display: block;
		}
		body {
		    line-height: 1;
			/* height: 100%; */
		}
		ol, ul {
		    list-style: none;
		}
		blockquote, q {
		    quotes: none;
		}
		blockquote:before, blockquote:after,
		q:before, q:after {
		    content: '';
		    content: none;
		}
		table {
		    border-collapse: collapse;
		    border-spacing: 0;
		}
		#app{
			height: 100%;
		}
	</style>
